import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  MessagingResponse,
  MessagingCreativeGalleryPayload,
  MessagingCreativeGalleryResponse,
  MessagingCreativeDataPayload,
  MessagingCreativeDataResponse
} from '../components/messaging-screen/types';
import { MessagingFiltersPayload } from './dashboard.service';
import { formatDateRangeForFilters } from '../utils/time';
import { CommunicationService } from '../http/communication.service';

@Injectable({
  providedIn: 'root'
})

export class MessagingService {
  constructor(private communicationService: CommunicationService) {}

  getMessagingData(payload: MessagingFiltersPayload): Observable<MessagingResponse> {
    return this.communicationService.httpPost<MessagingResponse>(`/dashboard/messaging/theme-category`,  {...payload, ...formatDateRangeForFilters(payload)}).pipe(
      catchError((error) => {
        console.error('Error fetching messaging data', error);
        throw error;
      }
    ));
  }

  getCreativeGallery(payload: MessagingCreativeGalleryPayload): Observable<MessagingCreativeGalleryResponse> {
    return this.communicationService.httpPost<MessagingCreativeGalleryResponse>(
      '/dashboard/messaging/creative-gallery',
      { ...payload, ...formatDateRangeForFilters(payload) }
    ).pipe(
      catchError(() =>
        of({
          creativesData: [],
          total: 0,
          themes: []
        } as MessagingCreativeGalleryResponse)
      )
    );
  }

  getCreativeData(payload: MessagingCreativeDataPayload): Observable<MessagingCreativeDataResponse> {
    return this.communicationService.httpPost<MessagingCreativeDataResponse>(
      '/dashboard/messaging/creative-data',
      { ...payload, ...formatDateRangeForFilters(payload) }
    ).pipe(
      catchError((error) => {
        console.error('Error fetching creative data', error);
        throw error;
      })
    );
  }

  getCreativeGalleryFile(payload: MessagingCreativeGalleryPayload) {
    return this.communicationService.httpPostBlob(
      '/dashboard/messaging/creative-gallery/file',
      { ...payload, ...formatDateRangeForFilters(payload) }
    ).pipe(
      map((response) => {
        const blob = response.body;
        if (!blob) return null;

        const contentDisposition = response.headers.get('content-disposition');
        let filename = 'creative-gallery.xlsx';
        if (contentDisposition) {
          const match = contentDisposition.match(/filename=([^;]+)/);
          if (match) {
            filename = match[1].trim();
          }
        }

        return { fileUrl: window.URL.createObjectURL(blob), filename };
      }),
      catchError((error) => {
        console.error('Error downloading creative gallery file', error);
        throw error;
      })
    );
  }
}

